import React from "react";
// --------------------------------------------------------------------------------------------
export interface CheckboxProps {
    key?: string | number;
    value: boolean;
    checkedIcon?: string;
    uncheckedIcon?: string;
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}
// --------------------------------------------------------------------------------------------
export default function Checkbox(props: CheckboxProps) {
    let icon = props.uncheckedIcon ?? "far fa-square";
    if (props.value)
        icon = props.checkedIcon ?? "fas fa-check-square";

    return <div
        key={props.key}
        className={`${icon} ${props.className ?? ""}`}
        style={{
            fontSize: "20px",
            color: "#039d77",
            pointerEvents: props.onClick ? 'auto' : 'none',
            cursor: props.onClick ? "pointer" : "none",
            ...props.style
        }}
        onClick={props.onClick} />
}

// --------------------------------------------------------------------------------------------